import { useMutation, useQuery, useQueryClient } from "react-query";
import { useClientsState, ClientsState } from "atoms/clientsAtom";

import { deleteClient, getClients } from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();
  const { setClientsState } = useClientsState();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-clients"] });

    setClientsState((prev: ClientsState) => ({
      ...prev,
      activeItems: [],
      activeItem: null
    }));
  };
};

export const useGetClients = () => {
  const { clientsState } = useClientsState();

  return useQuery(
    ["get-clients", clientsState.activeGroupItem?.clientgroupid],
    () => getClients(clientsState.activeGroupItem?.clientgroupid)
  );
};

export const useDeleteClient = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-client"], deleteClient, {
    onSuccess,
  });
};
